﻿import React, { createContext, useState, useMemo } from "react";
//import { FilterFacilities } from './partials/Filters'

export const initFacilitySearchContext = {
  country: document.querySelector('html').getAttribute('country'),
  showLoadingScreen: true,
  advSearch: !document.querySelector('.simple-search'),
  showPriceSuggestionBox: !document.querySelector('.hide-price-suggestion-box'),
  showDarkerNewStyle: !document.querySelector('.no-darker-theme'),
  showAdvancedFilters: !document.querySelector('.hide-advanced-filters'),
  isSearchButtonDisabled: !document.querySelector('.no-darker-theme'), //true when darker-theme
  init: true,
  searchDate: null,
  selectedLocation: null,
  returnToOriginalPosition: false,
  lastKnownLocation: null,
  filtersOpen: false,
  updateMarkers: true,
  filterSelection: {
    disabled: false,
    electricChargingPoint: false,
    Indoor: false,
    Outdoor: false,
    Heated: false,
    MaxVehicleHeight: false,
    LTP: false,
    STP: false,
    ParkingSpaceTypeSelection: {},
  },
  mapViewOpen: false,
  mapElementInDom: null,
  mapPosition: null,
  mapZoom: 15,
  mapBounds: null,
  updateMapBounds: false,
  allFacilities: null,
  filteredFacilities: null,
  visibleFacilities: null,
  panOnLoad: true,
  focusedFacility: null,
  filterOnInit: false,
  showOnMap: null,
}

export const FacilitySearchContext = createContext(null)

export const FacilitySearchContextProvider = (props) => {
  const initContext = initFacilitySearchContext;

  const [facilitySearchContext, setFacilitySearchContextTmp] = useState(initContext)

  const setFacilitySearchContext = (state) => {
    //if (state.allFacilities && JSON.stringify(facilitySearchContext.allFacilities || []) !== JSON.stringify(state.allFacilities || [])) {
    //  const filteredFacilities = FilterFacilities(state.allFacilities, facilitySearchContext.filterSelection);
    //  setFacilitySearchContextTmp({...state, filteredFacilities});
    //} else {
    //  setFacilitySearchContextTmp(state);
    //}

    setFacilitySearchContextTmp(state);
  }

  const facilitySearchState = useMemo(() => ({ facilitySearchContext, setFacilitySearchContext }), [facilitySearchContext, setFacilitySearchContext]);

  return (
    <FacilitySearchContext.Provider value={facilitySearchState}>
      {props.children}
    </FacilitySearchContext.Provider>
  )
}

const UserLocation = () => {
  if (navigator.geolocation) {
    navigator.geolocation.getCurrentPosition((position) => {
      return {
        lat: position.coords.latitude,
        lng: position.coords.longitude,
      };
    });
  } else {
    return {
      lat: null,
      lng: null,
    }
  }
}
